module.exports = __webpack_public_path__ + "static/scale-model-of-carew-tower-observation-deck-in-cincinnati-ohio-2c3069b2674dc0a83e15fbe7bc607b7a.png";